const CACHE_KEY = 'ss_catalog';
const CACHE_META_KEY = 'ss_catalog_meta';
// Short TTL so admin-side visibility toggles propagate to customers quickly.
// Cache still saves a roundtrip on tab-flipping within a normal ordering session.
const CACHE_TTL = 2 * 60 * 1000; // 2 minutes

export function getCachedCatalog() {
  try {
    const meta = JSON.parse(sessionStorage.getItem(CACHE_META_KEY));
    if (!meta || Date.now() - meta.timestamp > CACHE_TTL) return null;
    return JSON.parse(sessionStorage.getItem(CACHE_KEY));
  } catch {
    return null;
  }
}

export function setCachedCatalog(data) {
  try {
    const json = JSON.stringify(data);
    if (json.length > 4 * 1024 * 1024) {
      console.warn('Catalog too large to cache:', (json.length / 1024 / 1024).toFixed(1), 'MB');
      return;
    }
    sessionStorage.setItem(CACHE_KEY, json);
    sessionStorage.setItem(CACHE_META_KEY, JSON.stringify({ timestamp: Date.now() }));
  } catch (e) {
    console.warn('Failed to cache catalog:', e.message);
  }
}

// The cached catalog carries the signed-in account's prices (tier, specials),
// so it is dropped whenever someone signs in or out.
export function clearCachedCatalog() {
  try {
    sessionStorage.removeItem(CACHE_KEY);
    sessionStorage.removeItem(CACHE_META_KEY);
  } catch { /* storage blocked */ }
}
